import { isFeature } from 'Cloud/Application/FeaturesEs6';

// CLOUDWEB-19154: Раздел Документы включение сортировки в разделе. Используется v4 метод, без него нет смысла включать сортировку
export const IS_ALL_DOC_SORT_ENABLED = isFeature('is-alldocuments-sort-enabled') && isFeature('is-alldocuments-feed-v4-enabled');

// CLOUDWEB-19140: Раздел Документы включение сортировки в пошаренных файлах, зависит от общей сортировки
export const IS_ALL_DOC_SHARED_SORT_ENABLED = isFeature('is-alldocuments-shared-sort-enabled') && isFeature('is-alldocuments-sort-enabled');
